import React, { useEffect, useState } from "react";
import { useGeoApps } from "@mapgear/geoapps-ui-framework";
import { Search } from "./Search";
import { Popup } from "./Popup";

export type ControlProps = {
    leftPanelOpen: boolean
}

export const Controls = (props: ControlProps): JSX.Element => {
    const { geoapps } = useGeoApps();
    const [isFullscreen, setIsFullscreen] = useState(false);
    const map = geoapps.GetMap("map");

    /**
     * handle fullscreen changes
     */
    useEffect(() => {
        function onFullscreenChange() {
            setIsFullscreen(Boolean(document.fullscreenElement));
        }

        document.addEventListener("fullscreenchange", onFullscreenChange);

        return () => document.removeEventListener("fullscreenchange", onFullscreenChange);
    }, []);

    /**
     * Toggles fullscreen mode
     */
    const toggleFullscreen = () => {
        if (isFullscreen) {
            document.exitFullscreen();
        } else {
            document.body.requestFullscreen();
        }
    };

    /**
     * Map zoom in function
     */
    const zoomIn = () => {
        if (!map) return;
        map.ZoomIn();
    };

    /**
     * Map zoom out function
     */
    const zoomOut = () => {
        if (!map) return;
        map.ZoomOut();
    };

    /**
     * Zoom to home function
     */
    const zoomToHome = () => {
        if (!map) return;
        map.ZoomToHome();
    };

    return (
        <div className={props.leftPanelOpen ? "controls sidebar-open" : "controls"}>
            <div className="control-group">
                <a onClick={zoomIn} title="Zoom in" role="button" aria-label="Zoom in">
                    <i className="fa-solid fa-plus"></i>
                </a>
                <a onClick={zoomToHome} title="Home" role="button" aria-label="Home">
                    <i className="fa fa-house-chimney"></i>
                </a>
                <a onClick={zoomOut} title="Zoom out" role="button" aria-label="Zoom out">
                    <i className="fa-solid fa-minus"></i>
                </a>
            </div>
            <div className="control-group">
                <a title={isFullscreen ? "Close Fullscreen" : "View Fullscreen"} onClick={() => toggleFullscreen()}>
                    <i className={isFullscreen ? "fa-solid fa-compress" : "fa-solid fa-expand"}></i>
                </a>
            </div>
            <Search />
            <Popup />
        </div>
    );
};
